<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Paquetes</a>
  </div>
  <h1 class="ui header"><img class="ui image" src="../../assets/parcels.png">
    <div class="content">Envíos</div>
  </h1>
  <div class="ui stackable ">
    <div class="row">
      <h4 class="ui dividing header">Buscar un paquete</h4>
        <filterMaster :theRole="role" :theSearch="search" @filtersSelected="searchParcel"></filterMaster>
    </div>
    <div v-if="(searching && rows.length==0)" class="ui active centered inline loader"></div>
    <div v-if="(rows.length!=0)" class="row">
      <div class="column">
        <vue-good-table :columns="columns" :rows="rows" :lineNumbers="true" :pagination-options="{
                perPage: 50,
                enabled: true,
                mode: 'pages'
                }" :sort-options="{
                enabled: true,
                initialSortBy: {field: 'lastUpdate', type: 'desc'}
                }"
          @on-row-click="parcelInfo" styleClass="vgt-table striped condensed bordered">
          >
        </vue-good-table>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import filterMaster from '@/components/filterMaster.vue'
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'localParcelList',
  props: ['id'],
  data() {
    return {
      parcels: null,
      searching: null,
      role: null,
      search: {
        'phone': null,
        'email': null,
        'codigo': null,
        'estado': null,
        'name': null,
        'cliente': null,
        'maquina': null,
        'fechaDesde': null,
        'fechaHasta': null,
      },
      columns: [{
          label: 'Locker',
          field: 'apm',
          filterOptions: {
            placeholder: 'Locker',
            enabled: true, 
            trigger: 'keyup',
          }
        },
        {
          label: 'Comercio',
          field: 'local_user',
          filterOptions: {
            placeholder: 'Comercio',
            enabled: true, 
            trigger: 'keyup',
          }
        },
        {
          label: 'Nombre',
          field: 'name',
          filterOptions: {
            placeholder: 'Nombre',
            enabled: true, 
            trigger: 'keyup',
          }
        },
        {
          label: 'Telefono',
          field: 'phone',
          filterOptions: {
            placeholder: 'Teléfono',
            enabled: true,
            trigger: 'keyup',
          }
        },
        {
          label: 'Estado',
          field: 'status',
          filterOptions: {
            placeholder: 'Estado',
            enabled: true, // enable filter for this column
            trigger: 'enter', //only trigger on enter not on keyup
          }
        },
        {
          label: 'Ult. Actualización',
          field: 'lastUpdate',
          width: '120px',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'yyyy-MM-dd HH:mm:ss',
        },
      ],
      rows: [],
    }
  },
  created() {
    this.searching = false
  },
  methods: {
    searchParcel(filtersSelected) {
      this.search = JSON.parse(JSON.stringify(filtersSelected));
      let aux = false;
      for(var usedfilters in this.search) {
        if(this.search.hasOwnProperty(usedfilters)) {
          aux = true;
        }
      }
      this.searching = true
      this.rows = []
      if (this.search.startDate > this.search.endDate){
        this.$swal({
          type: 'info',
          text: 'La fecha inicio no puede ser superior a la fecha fin'
        })
        return this.rows.push({
          'from': 'no encontrado',
        })
      }

      if (this.search.endDate && !this.search.startDate){
        this.$swal({
          type: 'info',
          text: 'Debe seleccionar una fecha de inicio'
        })
      } else {
        hapiickApi().post('/v4/shipments/search', {
          admin_id: JSON.parse(localStorage.admin).id,
          search: this.search
        })
        .then(request => {
          this.updateTable(request)
        })
        .catch((err) => {
          let type = '';
          let title = '';
          let text = '';
          let html = '';
          if (err.message === 'Network Error') {
            type = 'info'
            html= '<div style="font-size:20px!important"><p>Se ha producido un error inesperado.</p>'+
            '<b style="font-weight:bold!important;">Intenta acotar la busqueda</b></br>'+
            'Si el error persiste, por favor, pongase en contacto con hapiick.</div>';
          } else if (err.message === "Cannot read property 'parcels' of undefined" || err.message === "Request failed with status code 500") {
            type = 'error'
            title = 'Error interno!'
            text = 'Por favor, pongase en contacto con hapiick.'
          } else {
            type = 'error'
            title = 'Error'
            text = 'Error al obtener los paquetes.'
          }

          this.$swal({
            type: type,
            title: title,
            text: text,
            html: html
          })

          this.rows.push({
            'from': 'no encontrado',
          })
        })
      }
    },
    updateTable(req) {
      let parcels = []
      parcels = JSON.parse(JSON.stringify(req.data.data.parcels))
      this.parcels = parcels;
      if (parcels.length == 0) {
        this.rows.push({
          'apm': 'no data',
        })
      } else {
        this.rows = parcels.map((parcel) => ({
          'apm': parcel.apm,
          'id': parcel.id,
          'local_user': parcel.nameRemi,
          'name': parcel.name,
          'phone': parcel.phone,
          'status': parcel.status,
          'lastUpdate': parcel.lastUpdate,
        }))
      }
    },
    goTo(where) {
      this.$router.push(where,'')
    },
    parcelInfo(params) {
      let localId = this.id;
      let pakageId = params.row.id

      if(localId){
        this.goTo('/local/'+localId+'/parcels/'+pakageId+'/info', 'localParcelInfo')
      } else {
        this.goTo('/local/parcels/info/'+pakageId, 'localParcelInfo')
      }
    },
  },
  components: {
    'filterMaster': filterMaster
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Local/localParcelList.vue